import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getUsersHunters, type SortDirection } from "Infrastructure/Api/Api";
import { MS_TIME } from "Utils/TimeUtils";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const HUNTERS_LIST_QUERY_KEY = "HUNTERS_LIST";

export type HuntersListParams = {
  offset: number;
  limit: number;
  sortBy?: string;
  sortDirection?: SortDirection;
  prerequisites?: string;
  search?: string;
  login?: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  affiliatedTo?: string;
  dateCreatedFrom?: string;
  statuses?: Array<string>;
};

export const huntersListKeys = {
  all: [HUNTERS_LIST_QUERY_KEY],
  byParams: (params: HuntersListParams) => [...huntersListKeys.all, params],
};

export const useHuntersListQuery = (params: HuntersListParams) =>
  useQuery({
    queryKey: huntersListKeys.byParams(params),
    queryFn: processResponseWithApiProblemDetails(() =>
      getUsersHunters(
        params.prerequisites,
        params.search,
        params.login,
        params.firstName,
        params.lastName,
        params.companyName,
        params.affiliatedTo,
        params.dateCreatedFrom,
        params.statuses,
        params.offset,
        params.limit,
        params.sortBy,
        params.sortDirection,
      ),
    ),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * MS_TIME.minute,
  });
